module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"advisory_services":{"action":"Choose service(s)","empty_state":"Select the advisory services that you offer. This way, interested parties know that they can contact you.<br/><br/> Please note: To be found by others, you must select at least one service option!","title":"Advisory services"}}}}}}}')
  delete Component.options._Ctor
}
